import React, {useEffect, useState} from 'react'
import { inputTypes } from '../../../libs/react-mpk/config/constant'
import { FormWrapper } from '../../../libs/react-mpk/wrapper'
import t from 'counterpart'
import { inject, observer } from 'mobx-react'
import service from './DetailModal.service'
import EntitasService from '../../master/Entitas/Entitas.service'
import Utils from '../../../libs/custom/Utils'
import PerusahaanListService from '../../master/Perusahaan/Perusahaan.service'

const DetailModalForm = ({envStore, match, history, sipStore, navigationStore}) => {
  const { inputTypes, definition } = FormWrapper
  const [perusahaanList, setPerusahaanList] = useState([])
  const [data, setData] = useState({loading: true, content: {}})
  const [entitasList, setEntitasList] = useState([])
  const [entitasMap, setEntitasMap] = useState({})

  // initial data
  useEffect(() => {
    async function initData() {
      // await _getPerusahaanList()
      // await _getEntitasList()

      if(match.params.id == 'baru') {
        setData({loading: false, content: {
          migrasiTranskripId: match.params.migrasiTranskripId,
          perusahaanId: sipStore.companyId,
          periodeFiskalId: sipStore.periodeId,
          tahunPajak: sipStore.periode.tahun
        }})
        return true
      }
      const res = await service.getOne(match.params.id)
      res.data = Utils.formSerialize(res.data)
      setData({loading: false, content:res.data})
    }
    initData()
  }, ['match.params.id'])

  async function _getPerusahaanList() {
    var res = await PerusahaanListService.get()
    setPerusahaanList(res.data.map(x => ({value: x.id, label: x.nama})))
  }

  return (
    <FormWrapper
    noValidate
    customRules={{
      npwp: 'required|size:15'
    }}
      loading={data.loading}
      actions={[
        {
          label: 'Reload',
          iconClassName: 'mdi mdi-reload'
        }
      ]}
      backTo={`/onpremise/periode-fiskal-saldo-awal`}
      baseId="mod-form-sample"
      title='Migrasi'
      // hintMessage={t.translate('modules.form.hint.message')}
      hintShowIcon={false}
      defaultData={data.content}
      definitions={[
        // =====
        {
          inputType: inputTypes.INPUT,
          label: 'Nama',
          key: 'nama',
          width: '100%',
          required: true,
          validation: 'required'
        },
        {
          inputType: inputTypes.INPUT_MASK_NUMBER,
          mask: '##.###.###.#-###.###',
          maskChar: '_',
          maskValue: 'string',
          label: 'NPWP',
          key: 'npwp',
          type: 'text',
          width: '100%',
          validation: 'required'
        },
        {
          inputType: inputTypes.INPUT,
          label: 'Alamat',
          key: 'alamat',
          width: '100%',
        },
        {
          inputType: inputTypes.INPUT_MASK_NUMBER,
          label: 'Nilai',
          key: 'nilai',
          width: '100%',
          thousandSeparator: '.',
          decimalSeparator: ',',
          isNumericString: true,
          required: true,
          validation: 'required'
        }
      ]}
      onSubmit={async (data, callback) => {
        var res = {}
        try {
          console.log(entitasMap, 'asd')
          data = Utils.formNormalize(data)
          data.tahunPajak = parseInt(data.tahunPajak)
          if(match.params.id == 'baru') {
            res = await service.post(data)
          } else {
            res = await service.put(data)
          }
          callback(t.translate('global.dataTelahDiSimpan'), false)
          history.push('/onpremise/periode-fiskal-saldo-awal')
        } catch(e) {
          callback(e, true, false)
        }
      }}
    />
  )
}

export default inject('sipStore', 'navigationStore')(observer(DetailModalForm))
